const setCurrentHealthActions = (state, healthActions) => {
  Object.assign(state, {
    currentHealthActions: healthActions.map(actionsGroup => ({
      ...actionsGroup,
      isFollowUp: !!actionsGroup.actions[0]?.autoExec,
      actions: actionsGroup.actions.map(action => ({
        ...action,
        checked: true
      }))
    }))
  })
}

const setChoosenHealthActions = (state, healthActions) => {
  const choosenHealthActions = [healthActions]
  Object.assign(state, { choosenHealthActions })
}

const clearChoosenHealthActions = state => {
  Object.assign(state, { choosenHealthActions: undefined })
}

const clearCurrentHealthActions = state => {
  Object.assign(state, {
    currentHealthActions: []
  })
}

// TODO: unify toggle, edit and save into a single mutation
const toggleHealthAction = (state, payload) => {
  const updatedActions = [...state.currentHealthActions].map(actionsGroup => ({
    ...actionsGroup,
    actions:
      actionsGroup.id === payload.groupId
        ? actionsGroup.actions.map(action => ({
            ...action,
            checked:
              action.id === payload.actionId ? payload.checked : action.checked
          }))
        : actionsGroup.actions
  }))
  const updatedChoosenHealthActions = state.choosenHealthActions
    ? [
        updatedActions.find(
          group => group.id === state.choosenHealthActions[0].id
        )
      ]
    : undefined

  Object.assign(state, {
    currentHealthActions: updatedActions,
    choosenHealthActions: updatedChoosenHealthActions
  })
}

const editHealthAction = (state, payload) => {
  const updatedActions = [...state.currentHealthActions].map(actionsGroup => ({
    ...actionsGroup,
    actions:
      actionsGroup.id === payload.groupId
        ? actionsGroup.actions.map(action => {
            if (action.id === payload.action.id) {
              return {
                ...action,
                ...payload.action
              }
            }
            return action
          })
        : actionsGroup.actions
  }))

  Object.assign(state, {
    currentHealthActions: updatedActions
  })
}

const createHealthAction = (state, payload) => {
  const updatedActions = [...state.currentHealthActions].map(actionsGroup => ({
    ...actionsGroup,
    actions:
      actionsGroup.id === payload.groupId
        ? [...actionsGroup.actions, payload.action]
        : actionsGroup.actions
  }))

  Object.assign(state, {
    currentHealthActions: updatedActions
  })
}

export default {
  setCurrentHealthActions,
  setChoosenHealthActions,
  clearChoosenHealthActions,
  clearCurrentHealthActions,
  toggleHealthAction,
  editHealthAction,
  createHealthAction
}
